import { useNotification } from '@/hooks/useNotification';

import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

import styles from './Notification.module.scss';

export function Notification() {
  const { isVisible, hideNotification, message, severity } = useNotification();

  return (
    <div>
      <Snackbar
        className={styles.notification}
        open={isVisible}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={hideNotification}
      >
        <Alert
          className={styles.notification__alert}
          onClose={hideNotification}
          severity={severity}
          variant="filled"
        >
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
}
